import { Box, CardMedia } from "@mui/material";
import { PARTS_RESOURCES } from "../../../configuration/Resources";
import ImageTooltip from "../../AppTooltip/ImageTooltip";
import { GridRenderCellParams } from "@mui/x-data-grid";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { AppIconsCamera } from "../../AppIcons";

const PartImageComponent: React.FC<{
  fileName: string;
}> = ({ fileName }) => {
  return (
    <Box>
      {fileName && fileName !== "" && (
        <ImageTooltip
          imageStyle={{ maxWidth: 150 }}
          imagePath={`${PARTS_RESOURCES}/${fileName?.substring(
            0,
            2
          )}/${fileName}.thumb.300.jpg`}
        >
          <CardMedia
            component="img"
            sx={{ height: "25px" }}
            image={`${PARTS_RESOURCES}/${fileName?.substring(
              0,
              2
            )}/${fileName}.thumb.300.jpg`}
          />
        </ImageTooltip>
      )}
    </Box>
  );
};

export function renderImage(params: GridRenderCellParams<any, string>) {
  if (params.value == null || params.value == "") {
    return "";
  }
  return (
    <Box>
      {params.value && params.value !== "" && (
        <ImageTooltip
          imageStyle={{ maxWidth: 150 }}
          imagePath={`${PARTS_RESOURCES}/${params.value?.substring(0, 2)}/${
            params.value
          }.thumb.300.jpg`}
        >
          <AppIconsCamera />
        </ImageTooltip>
      )}
    </Box>
  );
}
